import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';
import { GET_TRANSACTION_DETAILS_BY_CLAIM_ID } from '@/modules/transaction/hooks/useGetTransactionDetails.query';

interface Payload {
  payment_method_id?: string;
  repayment_amount?: number;
}

const useStartRepaymentQuery = (
  onSuccess: () => void,
  onError: (errorText?: string) => void,
  claimId?: string
) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (payload: Payload) => api.post(PATHS.START_CLAIM_REPAYMENT(claimId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_TRANSACTION_DETAILS_BY_CLAIM_ID, claimId],
        });
        if (onSuccess) onSuccess();
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (data?: any) => {
        onError(data?.response?.data?.elevate_error_message);
      },
    }
  );

  return {
    startRepayment: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useStartRepaymentQuery;
